import React, { useState, useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import Select from "react-select";
import axios from "axios";
import Grid from "@material-ui/core/Grid";
import swal from "sweetalert";
import * as XLSX from "xlsx";
import {
  DataGrid,
  Column,
  Selection,
  FilterRow,
  HeaderFilter,
  FilterPanel,
} from "devextreme-react/data-grid";
import DateBox from "devextreme-react/date-box";
import { api_path } from "../../shared.js";
import Button1 from "@material-ui/core/Button";
import TagBox from "devextreme-react/tag-box";
import CustomerCampaignDatagrid from "./CustomerCampaignDatagrid";
function MainCampaignForm({ CAMPAIGN_ID, onDataChange }) {
  const now = new Date();
  const dateLabel = { "aria-label": "Date" };
  const userId = JSON.parse(localStorage.getItem("USER_ID"));
  const getFName = JSON.parse(localStorage.getItem("USER_FIRSTNAME"));
  const token = process.env.REACT_APP_API_TOKEN;
  const [getCampaignName, setCampaignName] = useState("");

  const [getCampaignBudget, setCampaignBudget] = useState("");
  const [getSource, setSource] = useState([]);
  const [getSourceList, setSourceList] = useState([]);
  const [getCampaignPurpose, setCampaignPurpose] = useState("");
  const [getTag, setTag] = useState([]);
  const [getSelectedTag, setSelectedTag] = useState();
  const [getSelectSource, setSelectedSource] = useState([]);
  const [getCampaignOwner, setCampaignOwner] = useState([]);
  const [getSelectedCampaignOwner, setSelectedCampaignOwner] = useState([]);
  const [getCampaignOwnerList, setCampaignOwnerList] = useState([]);
  const [getNote, setNote] = useState("");
  const [getCampaignStatus, setCampaignStatus] = useState("");
  const [getCampaignStatusName, setCampaignStatusName] = useState("");
  const [duplicateData, setDuplicateData] = useState([]);
  const [similarData, setSimilarData] = useState([]);
  const [validData, setValidData] = useState([]);
  const [showUploadMsg, setShowUploadMsg] = useState(
    "Choose file before Pressing the Upload button."
  );
  const [checkUplodaFile, setUplodaFile] = useState(false);
  const [getMinDate, setMinDate] = useState(null);
  var date = new Date();
  const formattedtoday2 = date
    .toLocaleDateString("en-GB", {
      year: "2-digit",
      month: "2-digit",
      day: "2-digit",
    })
    .split("/")
    .reverse()
    .join("");
  function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1) + min);
  }
  const [GET_RANDOM_KEY, SET_RANDOM_KEY] = useState(
    formattedtoday2 + "" + Math.floor(date.getTime() / 1000)
  );
  const fetchSale = () => {
    axios
      .get(api_path + `/GET_SALES.php?role=BU_LEADER`)
      .then((response) => {
        setCampaignOwnerList(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleCampaignOwnerChange = (obj) => {
    setSelectedCampaignOwner(obj.SALE_CODE);
    setCampaignOwner({ SALE_CODE: obj.SALE_CODE, SALE_NAME: obj.SALE_NAME });
  };
  const fetchSourceStatus = () => {
    axios
      .get(`${api_path}/customer/campaign-master.php?type=CAMPAIGN_SOURCE`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setSourceList(response.data);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const handleSourceChange = (obj) => {
    setSelectedSource(obj.CAMPAIGN_MASTER_VALUE);
    setSource({
      CAMPAIGN_MASTER_VALUE: obj.CAMPAIGN_MASTER_VALUE,
      CAMPAIGN_MASTER_EN: obj.CAMPAIGN_MASTER_EN,
    });
  };
  const buList = [
    { value: "AIR", label: "AIR" },
    { value: "FOOD", label: "FOOD" },
    { value: "TIRE", label: "TIRE" },
    { value: "REEFER", label: "REEFER" },
    { value: "ISOTANK", label: "ISOTANK" },
    { value: "SOC", label: "SOC" },
    { value: "WORLDWIDE", label: "WORLDWIDE" },
    { value: "SALES", label: "SALES" },
    { value: "SEA TP", label: "SEA TP" },
    { value: "SEA NON-TP", label: "SEA NON TP" },
    { value: "IMPORT", label: "IMPORT" },
    { value: "LCL", label: "LCL" },
  ];
  const tagToOwner = {
    AIR: {
      SALE_CODE: "79",
      SALE_NAME: "kritpong.b@sinologistics.co.th",
    },
    FOOD: {
      SALE_CODE: "70",
      SALE_NAME: "supanatsiree.l@sinologistics.co.th",
    },
    TIRE: {
      SALE_CODE: "94",
      SALE_NAME: "raweenun.m@sinologistics.co.th",
    },
    REEFER: { SALE_CODE: "95", SALE_NAME: "surat.c@sinologistics.co.th" },
    ISOTANK: {
      SALE_CODE: "92",
      SALE_NAME: "Chayut.t@sinologistics.co.th",
    },
    SOC: { SALE_CODE: "80", SALE_NAME: "yindee.s@sinologistics.co.th" },
    WORLDWIDE: { SALE_CODE: "", SALE_NAME: "" }, // กรณีไม่มี owner
  };

  const handleTagChange = (obj) => {
    let tag = obj.value;
    setTag({ value: obj.value, label: obj.label });
    setSelectedTag(obj.value);
    // map campaign owner ตาม tag
    const owner = tagToOwner[tag] || { SALE_CODE: "", SALE_NAME: "" };
    setCampaignOwner(owner);
    setSelectedCampaignOwner(owner.SALE_CODE);
  };

  useEffect(() => {
    fetchSale();
    fetchSourceStatus();
    if (CAMPAIGN_ID > 0) {
      fetchData(CAMPAIGN_ID);
    } else {
      setCampaignStatus(0);
    }
  }, []);
  const fetchData = async (id) => {
    try {
      const res = await fetch(`${api_path}/customer/campaigns.php?id=${id}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await res.json();
      const i = data[0];
      setCampaignName(i.CAMPAIGN_NAME);
      setDateFrom(i.START_DATE);
      setDateTo(i.END_DATE);
      setNote(i.DESCRIPTION);
      setCampaignStatus(i.CAMPAIGN_STATUS);
      setCampaignStatusName(i.CAMPAIGN_STATUS_NAME);
      onDataChange && onDataChange({ status: i.CAMPAIGN_STATUS_NAME });
      setCampaignBudget(i.CAMPAIGN_BUDGET);
      setCampaignPurpose(i.CAMPAIGN_PURPOSE);
      setCampaignOwner({
        SALE_CODE: i.CAMPAIGN_OWNER,
        SALE_NAME: i.CAMPAIGN_OWNER_NAME,
      });
      setSelectedCampaignOwner(i.CAMPAIGN_OWNER);
      setSelectedSource(i.CAMPAIGN_SOURCE);
      setSource({
        CAMPAIGN_MASTER_VALUE: i.CAMPAIGN_SOURCE,
        CAMPAIGN_MASTER_EN: i.CAMPAIGN_SOURCE_NAME,
      });
      setSelectedTag(i.CAMPAIGN_TAG);
      setTag({
        value: i.CAMPAIGN_TAG,
        label: i.CAMPAIGN_TAG,
      });
      // if (i.CAMPAIGN_TAG) {
      //   // แปลง string "1,2,3" → array [1,2,3]
      //   const selectedArray = i.CAMPAIGN_TAG.split(",").map((id) => id.trim()); // trim กัน space
      //   setSelectedTag(selectedArray);
      // }
    } catch (error) {
      console.error("Failed to fetch customer:", error);
    }
  };
  const [getError, setError] = useState({
    cname: "",
    startdate: "",
    enddate: "",
    tag: "",
    channel: "",
    owner: "",
  });

  const validate = () => {
    let newErrors = {
      cname: "",
      startdate: "",
      enddate: "",
      tag: "",
      channel: "",
      owner: "",
    };
    if (!getCampaignName) {
      newErrors.cname = "Please input campaign name.";
    }
    if (!getDateFrom) {
      newErrors.startdate = "Please select start date.";
    }
    if (!getDateTo) {
      newErrors.enddate = "Please select end date.";
    }

    if (!getSelectedTag || getSelectedTag.length === 0 || getSelectedTag == 0) {
      newErrors.tag = "Please select tag.";
    }
    if (
      !getSelectSource ||
      getSelectSource.length === 0 ||
      getSelectSource == 0
    ) {
      newErrors.channel = "Please select channel.";
    }
    if (
      !getSelectedCampaignOwner ||
      getSelectedCampaignOwner.length === 0 ||
      getSelectedCampaignOwner == 0
    ) {
      newErrors.owner = "Please select campaign owner.";
    }

    setError(newErrors);

    return Object.values(newErrors).every((err) => err === "");
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!validate()) return;
    var data = {
      CAMPAIGN_NAME: getCampaignName,
      CAMPAIGN_TYPE: "",
      START_DATE: getDateFrom,
      END_DATE: getDateTo,
      CAMPAIGN_STATUS: getCampaignStatus,
      CAMPAIGN_TAG: getSelectedTag,
      DESCRIPTION: getNote,
      CAMPAIGN_SOURCE: getSelectSource,
      CAMPAIGN_BUDGET: getCampaignBudget,
      CAMPAIGN_OWNER: getSelectedCampaignOwner,
      CAMPAIGN_PURPOSE: getCampaignPurpose,
      CREATE_BY: userId,
      CAMPAIGN_ID: CAMPAIGN_ID,
    };
    console.log("Payload to PHP:", data); // ดู JSON ที่จะส่ง
    fetch(api_path + "/customer/campaigns.php", {
      method: "POST",
      headers: {
        Accept: "application/form-data",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result["status"] == "200") {
          swal("Done.", "Save data successfully.", "success", {
            buttons: true,
            timer: 1000,
          }).then(function () {
            window.location = "./CampaignDetail?id=" + result["message"];
          });
        } else {
          swal("Sorry", result["message"], "error", {
            buttons: true,
            timer: 10000,
          });
        }
      });
  };
  function checkIsAllowedType(selectedFiles) {
    const allowedTypes = [
      ".jpg",
      ".jpeg",
      ".png",
      ".gif",
      ".pdf",
      ".doc",
      ".docx",
      ".xls",
      ".xlsx",
      ".csv",
    ];
    return selectedFiles.some((file) => {
      const fileExtension = file.name.split(".").pop().toLowerCase();
      return allowedTypes.includes(`.${fileExtension}`);
    });
  }
  const [errorMessage, setErrorMessage] = useState("");
  const [files, setFiles] = useState([]);
  const [getFileName, setFileName] = useState([]);
  const [selectedfile, SetSelectedFile] = useState([]);
  const filesizes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  };
  const InputChange = (e) => {
    setShowUploadMsg("⚠️ Pressing the Upload button.");
    const selectedFiles = Array.from(e.target.files);
    var totalSize = 0;
    for (let i = 0; i < e.target.files.length; i++) {
      const file = selectedFiles[i];
      SetSelectedFile((preValue) => {
        return [
          ...preValue,
          {
            id: i,
            filename: e.target.files[i].name,
            filetype: e.target.files[i].type,
            filesize: filesizes(e.target.files[i].size),
          },
        ];
      });
      if (file) {
        totalSize += parseInt(file.size);
      }
    }
    const maxSize = 30 * 1024 * 1024; // 30MB
    if (totalSize > maxSize) {
      setErrorMessage("File size exceeds. It should be less than 30MB.");
      setShowUploadMsg("");
    } else {
      const isAllowedFiles = checkIsAllowedType(selectedFiles);
      if (!isAllowedFiles) {
        setErrorMessage(
          "Please select file jpg, jpeg, png, gif, pdf, doc ,docx, xls, xlsx, csv ."
        );
        setShowUploadMsg("");
      } else {
        setErrorMessage("");
        const commaString = selectedFiles
          .map((item) => GET_RANDOM_KEY + "_" + item.name)
          .join(",");
        setFileName(commaString.replaceAll(" ", ""));
        setFiles(selectedFiles);
      }
    }
  };
  ////////////////////
  const [data, setData] = useState([]);
  const [errors, setErrors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  // const handleFileUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
  //   const file = e.target.files?.[0];
  //   if (!file) return;

  //   const reader = new FileReader();
  //   reader.onload = async (event) => {
  //     const bstr = event.target && event.target.result;
  //     const wb = XLSX.read(bstr, { type: "binary" });
  //     const sheetName = wb.SheetNames[0];
  //     const ws = wb.Sheets[sheetName];
  //     const jsonData = XLSX.utils.sheet_to_json(ws);

  //     // ✅ ตรวจสอบชื่อซ้ำ
  //     const enrichedData = await checkDuplicateNames(jsonData);
  //     setData(enrichedData);
  //   };
  //   reader.readAsBinaryString(file);
  // };
  const checkDuplicateNames = async (rows) => {
    setLoading(true);

    const checkedRows = await Promise.all(
      rows.map(async (row) => {
        const result = await checkNameExists(
          row["CUSTOMER_NAME"],
          "",
          row["SALES_CODE"]
        );

        let status = "valid";
        if (result.duplicate.length > 0) status = "duplicate";
        else if (result.similar.length > 0) status = "similar";

        return {
          ...row,
          duplicate_status: status,
          duplicate_data: result.duplicate || [],
          similar_data: result.similar || [],
          valid_data: result.valid || [],
        };
      })
    );

    setLoading(false);
    return checkedRows;
  };
  // ฟังก์ชันอ่านไฟล์ Excel
  const handleFileUpload = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = async (event) => {
      const bstr = event.target.result;
      const wb = XLSX.read(bstr, { type: "binary" });
      const ws = wb.Sheets[wb.SheetNames[0]];
      const jsonData = XLSX.utils.sheet_to_json(ws);

      // ตรวจสอบ duplicate
      const enrichedData = await checkDuplicateNames(jsonData);

      // เพิ่ม tempId สำหรับ keyExpr
      const dataWithId = enrichedData.map((d, i) => ({ ...d, tempId: i }));

      // ตั้ง data state
      setData(dataWithId);

      // auto tick row ที่ valid
      const validRows = dataWithId.filter(
        (d) => d.duplicate_status.toLowerCase() === "valid"
      );
      setSelectedRowKeys(validRows.map((d) => d.tempId));
      setSelectedRows(validRows);
    };
    reader.readAsBinaryString(file);
  };
  // const checkDuplicateNames = async (rows) => {
  //   setLoading(true);

  //   const checkedRows = await Promise.all(
  //     rows.map(async (row) => {
  //       const result = await checkNameExists(row["CUSTOMER_NAME"]);

  //       // กำหนด status ตาม API
  //       let status = "valid";
  //       if (result.duplicate.length > 0) {
  //         status = "duplicate";
  //       } else if (result.similar.length > 0) {
  //         status = "similar";
  //       }

  //       return {
  //         ...row,
  //         duplicate_status: status,
  //         selected: status === "valid", // ✅ ติ๊กเฉพาะ valid
  //         duplicate_data: result.duplicate || [],
  //         similar_data: result.similar || [],
  //       };
  //     })
  //   );

  //   // แยก state สำหรับ table
  //   setDuplicateData(
  //     checkedRows.filter((r) => r.duplicate_status === "duplicate")
  //   );
  //   setSimilarData(checkedRows.filter((r) => r.duplicate_status === "similar"));
  //   setValidData(checkedRows.filter((r) => r.duplicate_status === "valid"));

  //   setLoading(false);
  //   return checkedRows;
  // };
  const checkNameExists = async (name, taxId = "", salesCode = "") => {
    try {
      const payload = { name, tax_id: taxId, salesCode: salesCode };
      console.log("📦 Data sent to API:", payload); // <--- ดูค่าก่อนส่ง

      const res = await fetch(
        `${api_path}/customer/check_duplicate_name_campaign.php`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      const result = await res.json();
      console.log("✅ API response:", result); // <--- ดูค่าที่ API ตอบกลับมา

      return result.data || { valid: [], similar: [], duplicate: [] };
    } catch (error) {
      console.error("❌ Error checking duplicate name:", error);
      return { valid: [], similar: [], duplicate: [] };
    }
  };

  var date = new Date();
  const past30Days = new Date(date);
  past30Days.setDate(past30Days.getDate() - 30);
  var firstDay = past30Days; // ✅ ตอนนี้เป็น Date object แล้ว

  var lastDay = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const formattedfirstDay = firstDay
    .toLocaleDateString("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    })
    .split("/")
    .reverse()
    .join("-");
  const formattedlastDay = lastDay
    .toLocaleDateString("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    })
    .split("/")
    .reverse()
    .join("-");
  const [getDateFrom, setDateFrom] = useState(formattedfirstDay);
  const [getDateTo, setDateTo] = useState(formattedlastDay);
  const onValueChangedDateFrom = React.useCallback((e) => {
    const dateFrom = new Date(e.value);
    const formattedDateFrom = dateFrom
      .toLocaleDateString("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .split("/")
      .reverse()
      .join("-");
    setDateFrom(formattedDateFrom);
    setMinDate(formattedDateFrom);
  }, []);
  const onValueChangedDateTo = React.useCallback((e) => {
    const dateTo = new Date(e.value);
    const formattedDateTo = dateTo
      .toLocaleDateString("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .split("/")
      .reverse()
      .join("-");
    setDateTo(formattedDateTo);
  }, []);
  const [extraParams, setExtraParams] = useState({
    CREATE_BY: userId,
    CAMPAIGN_TAG: "",
    CAMPAIGN_ID: CAMPAIGN_ID,
  });

  useEffect(() => {
    setExtraParams((prev) => ({
      ...prev,
      CAMPAIGN_TAG: getSelectedTag || "",
    }));
  }, [getSelectedTag]);
  const handleSavexx = () => {
    console.log("📦 getSelectedTag =", getSelectedTag);
  };
  const handleSave = () => {
    if (selectedRows.length === 0) {
      swal("แจ้งเตือน", "กรุณาเลือกแถวก่อน", "warning");
      return;
    }

    swal({
      title: "ยืนยันการบันทึก?",
      text: "คุณต้องการบันทึกข้อมูลนี้หรือไม่",
      icon: "warning",
      buttons: ["ยกเลิก", "ยืนยัน"],
      dangerMode: true,
    }).then((willSave) => {
      if (willSave) {
        const payload = {
          extra: extraParams,
          campaigns: selectedRows,
        };
        console.log("📦 payload ที่ส่ง:", payload);
        fetch(`${api_path}/customer/campaign_to_customer.php`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`, // ถ้ามี token
          },

          body: JSON.stringify(payload),
        })
          .then((res) => res.json())
          .then((result) => {
            if (result.status == "200") {
              swal("Done", "Save data successfully", "success").then(() => {
                window.location = "./CampaignDetail?id=" + CAMPAIGN_ID;
              });
            } else {
              swal("Sorry", result.message, "error");
            }
          })
          .catch((err) => {
            console.error(err);
            swal("Error", "เกิดข้อผิดพลาด", "error");
          });
      }
    });
  };
  const [selectedRows, setSelectedRows] = useState([]);
  const onSelectionChanged = (e) => {
    // e.selectedRowsData จะเก็บข้อมูลของทุก column ของแถวที่เลือก
    setSelectedRows(e.selectedRowsData);
  };
  const handleChangeBudget = (e) => {
    // ลบ comma ออกก่อน
    let rawValue = e.target.value.replace(/,/g, "");
    // ตรวจว่าค่าเป็นตัวเลข
    if (!isNaN(rawValue) && rawValue !== "") {
      setCampaignBudget(Number(rawValue).toLocaleString("en-US"));
    } else if (rawValue === "") {
      setCampaignBudget("");
    }
  };
  return (
    <Grid item xs={12} sm={12}>
      <form onSubmit={handleSubmit}>
        <Grid container className="Box" spacing={2}>
          <Grid item xs={12} sm={3}>
            <label>CAMPAIGN NAME</label>
            <span className="red">*</span>
            <TextField
              size="small"
              name="getCampaignName"
              variant="outlined"
              fullWidth
              id="getCampaignName"
              value={getCampaignName}
              onChange={(e) => setCampaignName(e.target.value)}
              inputProps={{ maxLength: 250 }}
            />
            {getError.cname && (
              <span className="error-message">{getError.cname}</span>
            )}
          </Grid>
          <Grid item xs={12} sm={3}>
            <label>BUDGET</label>
            <TextField
              size="small"
              name="getCampaignBudget"
              variant="outlined"
              fullWidth
              id="getCampaignBudget"
              value={getCampaignBudget}
              onChange={handleChangeBudget}
              //onChange={(e) => setCampaignBudget(e.target.value)}
              inputProps={{ maxLength: 50 }}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <label>TAG</label>
            <span className="red">*</span>
            <Select
              className="multiselect1"
              placeholder="Select..."
              value={getTag}
              options={buList}
              onChange={handleTagChange}
            />
            {getError.tag && (
              <span className="error-message">{getError.tag}</span>
            )}
          </Grid>

          <Grid item xs={12} sm={3}>
            <label>CHANNEL</label>
            <span className="red">*</span>
            <Select
              placeholder="Select..."
              value={getSource}
              options={getSourceList}
              onChange={handleSourceChange}
              getOptionLabel={(x) => x.CAMPAIGN_MASTER_EN}
              getOptionValue={(x) => x.CAMPAIGN_MASTER_VALUE}
            />
            {getError.channel && (
              <span className="error-message">{getError.channel}</span>
            )}
          </Grid>

          <Grid item xs={12} sm={3}>
            <label>START DATE</label>
            <span className="red">*</span>
            <DateBox
              styles={{
                menu: (provided) => ({ ...provided, zIndex: 9999 }),
              }}
              defaultValue={now}
              inputAttr={dateLabel}
              type="date"
              displayFormat="dd/MM/yyyy"
              value={getDateFrom}
              onValueChanged={onValueChangedDateFrom}
            />
            {getError.startdate && (
              <span className="error-message">{getError.startdate}</span>
            )}
          </Grid>

          <Grid item xs={12} sm={3}>
            <label>END DATE</label>
            <span className="red">*</span>
            <DateBox
              defaultValue={now}
              inputAttr={dateLabel}
              type="date"
              displayFormat="dd/MM/yyyy"
              value={getDateTo}
              min={getMinDate}
              onValueChanged={onValueChangedDateTo}
            />
            {getError.enddate && (
              <span className="error-message">{getError.enddate}</span>
            )}
          </Grid>
          <Grid item xs={12} sm={3}>
            <label>OWNER</label>
            <span className="red">*</span>

            <Select
              styles={{
                menu: (provided) => ({ ...provided, zIndex: 1000 }),
              }}
              placeholder="Select..."
              value={getCampaignOwner}
              options={getCampaignOwnerList}
              onChange={handleCampaignOwnerChange}
              getOptionLabel={(x) => x.SALE_NAME}
              getOptionValue={(x) => x.SALE_CODE}
            />
            {getError.owner && (
              <span className="error-message">{getError.owner}</span>
            )}
          </Grid>
          <Grid item xs={12} sm={3}>
            <label>CREATE BY</label>
            <span className="red">*</span>
            <TextField
              size="small"
              name="GET_CREATE_BY"
              variant="outlined"
              fullWidth
              id="GET_CREATE_BY"
              value={getFName}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <label>Campaign Purpose</label>
            <TextField
              size="small"
              name="getCampaignPurpose"
              variant="outlined"
              fullWidth
              id="getCampaignPurpose"
              value={getCampaignPurpose}
              onChange={(e) => setCampaignPurpose(e.target.value)}
              inputProps={{ maxLength: 100 }}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <label>Campaign Description</label>
            <TextField
              size="small"
              name="getNote"
              variant="outlined"
              fullWidth
              id="getNote"
              value={getNote}
              onChange={(e) => setNote(e.target.value)}
              inputProps={{ maxLength: 500 }}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <Button1 type="submit" variant="contained" color="primary">
              {CAMPAIGN_ID ? "Update Campaign details" : "Create Campaign"}
            </Button1>
          </Grid>
          {CAMPAIGN_ID && (
            <Grid item xs={12} sm={12}>
              <CustomerCampaignDatagrid
                CAMPAIGN_ID={CAMPAIGN_ID}
                CAMPAIGN_STATUS={getCampaignStatus}
              />
            </Grid>
          )}
          <Grid item xs={12} sm={12}></Grid>
        </Grid>
        {CAMPAIGN_ID && (
          <Grid item xs={12} sm={12} className="box3">
            &nbsp;<label className="head2">Upload file</label>&nbsp;&nbsp;&nbsp;
            <input
              type="file"
              accept=".xlsx, .xls"
              onChange={handleFileUpload}
              className="mb-4"
            />
            {errors.length > 0 && (
              <div className="text-red-500">
                <h4>พบข้อผิดพลาด:</h4>
                <ul className="list-disc pl-5">
                  {errors.map((err, idx) => (
                    <li key={idx}>{err}</li>
                  ))}
                </ul>
              </div>
            )}
            {data.length !== 0 && (
              <DataGrid
                dataSource={data}
                keyExpr="tempId"
                selectedRowKeys={selectedRowKeys}
                onSelectionChanged={(e) => {
                  setSelectedRows(e.selectedRowsData);
                  setSelectedRowKeys(e.selectedRowKeys);
                }}
                showBorders
              >
                <Selection mode="multiple" showCheckBoxesMode="always" />
                <FilterRow visible={true} applyFilter="auto" />
                <FilterPanel visible={true} />
                <HeaderFilter visible={true} />

                <Column
                  dataField="CUSTOMER_NAME"
                  caption="Customer name"
                  width={200}
                />
                <Column
                  dataField="SALES_CODE"
                  caption="Sales code"
                  width={100}
                  alignment="left"
                />
                <Column
                  dataField="SALES_FIRSTNAME"
                  caption="Sales name"
                  width={100}
                  alignment="left"
                  headerCellRender={() => (
                    <div style={{ textAlign: "center", fontWeight: "bold" }}>
                      Sales name
                    </div>
                  )}
                  cellRender={({ data }) => {
                    // ถ้ามี duplicate_data → ใช้อันแรก
                    if (data.duplicate_data?.length > 0) {
                      return data.duplicate_data[0].SALES_FIRSTNAME;
                    }

                    // ถ้าไม่มี → ใช้ชื่อจาก valid หรือจาก row เอง
                    return data.valid_data[0].SALES_FIRSTNAME;
                    //return data.SALES_FIRSTNAME || "-";
                  }}
                />
                <Column dataField="TAX_ID" />
                <Column dataField="CUSTOMER_TYPE" caption="Customer Type" />
                <Column dataField="REMARK" caption="Remark" />

                {/* แสดง duplicate_status พร้อมสีแยกกลุ่ม */}
                <Column
                  dataField="duplicate_status"
                  caption="Status"
                  cellRender={({ value }) => {
                    let color = "green";
                    let label = "Valid";

                    if (value?.toLowerCase() === "duplicate") {
                      color = "red";
                      label = "Duplicate";
                    } else if (value?.toLowerCase() === "similar") {
                      color = "orange";
                      label = "Similar";
                    }

                    return <span style={{ color }}>{label}</span>;
                  }}
                />

                {/* สามารถเพิ่มคอลัมน์แสดง duplicate_data / similar_data ได้ */}
                <Column
                  dataField="duplicate_data"
                  caption="Duplicate Info"
                  cellRender={({ data }) =>
                    data.duplicate_data?.map((d) => d.CUSTOMER_NAME).join(", ")
                  }
                />
                <Column
                  dataField="similar_data"
                  caption="Similar Info"
                  cellRender={({ data }) =>
                    data.similar_data?.map((d) => d.CUSTOMER_NAME).join(", ")
                  }
                />
              </DataGrid>
            )}
            {data.length !== 0 && (
              <Button1
                onClick={handleSave}
                disabled={data.length === 0}
                style={{ marginTop: "10px", padding: "8px 16px" }}
                variant="contained"
                color="success"
              >
                Save Selected rows to campaign
              </Button1>
            )}
            <div className="kb-attach-box mb-3">
              {selectedfile.map((data, index) => {
                const { id, filename, filesize } = data;
                return (
                  <div className="file-atc-box" key={id}>
                    <div className="file-detail">
                      <h6>{filename}</h6>
                      <p>
                        <span>Size : {filesize}</span>
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </Grid>
        )}
      </form>
    </Grid>
  );
}

export default MainCampaignForm;
